module.exports = __webpack_public_path__ + "static/mainsliderimage_logo-1.f33ba38c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mb/home/mainsliderimage_logo-1.png
// module id = 546
// module chunks = 35783957827783